import BaseEventsSingleton from '@paytrace/pt-skel/Event'

const singleton = {
  ...BaseEventsSingleton,

  GET_USERS_BY_ACCT_REQUEST: '::get-users-by-acct-request',
  GET_USERS_BY_ACCT_RESPONSE: '::get-users-by-acct-response',

  OPEN_NEW_TRANX_SEARCH_TAB: '::open-new-tab',

  SUPPORT_BUTTON_CLICK: '::support-button-clicked',
  GLOBAL_CLICK: '::global-click',

  GET_IP_REQUEST: '::net-get-ip',

  LOGIN_REQUEST: '::net-do-login',
  LOGIN_RESPONSE: '::net-do-login-res',

  SET_ACCESS_TOKEN: '::set-access-token',
  SET_REFRESH_TOKEN: '::set-refresh-token',
  SET_USERNAME: '::set-username',

  GET_CUSTOMER_LIST_REQUEST: '::net-get-customer-list',
  GET_CUSTOMER_LIST_RESPONSE: '::net-get-customer-list-res',

  GET_CUSTOMER_REQUEST: '::net-get-customer',
  GET_CUSTOMER_RESPONSE: '::net-get-customer-res',

  GET_CUSTOMERS_FROM_TOKEN_REQUEST: '::net-get-customers-from-token',

  GET_DISC_DATA_REQUEST: '::net-get-disc-data',
  GET_DISC_DATA_RESPONSE: '::net-get-disc-data-res',

  FILTER_CUSTOMER_LIST: '::filter-customer-list',

  LOGOUT: '::logout',

  REFRESH_TOKEN: '::net-refresh-token',

  SSO_TOKEN: '::net-sso-token',
  SSO_RESPONSE: '::net-sso-response',

  NETWORK_ERROR: '::network-error',

  RUN_TRANSACTION_PREVIEW_REQUEST: '::net-do-transaction-preview',
  RUN_TRANSACTION_PREVIEW_RESPONSE: '::net-do-transaction-preview-res',

  RUN_KEYED_SALE_CHECK: '::net-do-keyed-sale-check',
  RUN_KEYED_SALE_REQUEST: '::net-do-keyed-sale',
  RUN_KEYED_SALE_RESPONSE: '::net-do-keyed-sale-res',

  RUN_SWIPE_SALE_CHECK: '::net-do-swipe-sale-check',
  RUN_SWIPE_SALE_REQUEST: '::net-do-swiped-sale',
  RUN_SWIPE_SALE_RESPONSE: '::net-do-swiped-sale-res',

  RUN_MULTIPLE_TRANX_REQUEST: '::net-do-multiple-tranx',
  RUN_MULTIPLE_TRANX_RESPONSE: '::net-do-multiple-tranx-res',

  SEARCH_TRANSACTIONS_REQUEST: '::net-search-transactions',
  SEARCH_TRANSACTIONS_RESPONSE: '::net-search-transactions-res',

  BATCH_TRANSACTIONS_OP_REQUEST: '::net-batch-transactions-op',
  BATCH_TRANSACTIONS_OP_RESPONSE: '::net-batch-transactions-op-res',

  SOMETHING_LOADING: '::something-loading',
  DONE_LOADING: '::done-loading',

  GET_CTX_USER: '::net-get-ctx-user',
  SET_CTX_USER: '::net-set-ctx-user',

  BATCH_TRANSACTION_FEEDBACK: '::batch-transaction-feedback',
  BATCH_TRANSACTION_ERROR_FEEDBACK: '::batch-transaction-error-feedback',

  SEND_SINGLE_EMAIL_RECEIPT_REQ: '::net-email-receipt-req',
  SEND_SINGLE_EMAIL_RECEIPT_RES: '::net-email-receipt-res',

  GET_CONFIGURED_EMAIL_LIST_REQUEST: '::net-get-configure-email-list',
  GET_CONFIGURED_EMAIL_LIST_RESPONSE: '::net-get-configure-email-list-res',

  GET_MERCHANT_SURCHARGE_INFO_REQUEST: '::net-get-merchant-surcharge-info',
  GET_MERCHANT_SURCHARGE_INFO_RESPONSE: '::net-get-merchant-surcharge-info-res',

  GET_TRANSACTION_SURCHARGE_ELIGIBILITY_INFO_REQUEST: '::net-get-transaction-surcharge-eligibility-info',
  GET_TRANSACTION_SURCHARGE_ELIGIBILITY_INFO_RESPONSE: '::net-get-transaction-surcharge-eligibility-info-res',

  GET_TRANSACTION_PREVIEW_INFO_REQUEST: '::net-get-transaction-preview-info',
  GET_TRANSACTION_PREVIEW_INFO_RESPONSE: '::net-get-transaction-preview-info-res',

  GET_BIN_INFO_REQUEST: '::net-get-bin-info',
  GET_BIN_INFO_RESPONSE: '::net-get-bin-info-res',

  GET_TRANSACTION_BY_ID_REQUEST: '::net-get-transaction-by-id',
  GET_TRANSACTION_BY_ID_RESPONSE: '::net-get-transaction-by-id-res',

  POST_RECURRING_VIEW_PAYMENT_REQUEST: '::net-post-recurring-view-payment',
  POST_RECURRING_VIEW_PAYMENT_RESPONSE: '::net-post-recurring-view-payment-res',

  RUN_RECURRING_PAYMENT_POST_REQUEST: '::net-recurring-payment-post-req',
  RUN_RECURRING_PAYMENT_POST_RESPONSE: '::net-recurring-payment-post-res',

  RUN_RECURRING_PAYMENT_PUT_REQUEST: '::net-recurring-payment-put-req',
  RUN_RECURRING_PAYMENT_PUT_RESPONSE: '::net-recurring-payment-put-res',

  GET_RECURRENCE_REQUEST: '::net-get-single-recurring-req',
  GET_RECURRENCE_RESPONSE: '::net-get-single-recurring-res',

  GET_RECURRENCE_LIST_REQUEST: '::net-get-recurring-list-req',
  GET_RECURRENCE_LIST_RESPONSE: '::net-get-recurring-list-res',

  GET_ACH_MERCHANT_SETTINGS_REQUEST: '::net-get-ach-merchant-settings-req',
  GET_ACH_MERCHANT_SETTINGS_RESPONSE: '::net-get-ach-merchant-settings-res',

  GET_RECURRING_CHANGE_LOG_REQUEST: '::get-recurring-change-log-req',
  GET_RECURRING_CHANGE_LOG_RESPONSE: '::get-recurring-change-log-res',

  EDIT_PAYMENT_REQUEST: '::edit-payment',
  GET_RECURRING_EDIT_REQUES: '::get-edit-payment',

  GET_RECURRING_PAYMENT_REQUEST: '::net-get-recurring-payment',
  GET_RECURRING_PAYMENT_RESPONSE: '::net-get-recurring-payment-res',

  DELETE_RECURRING_PAYMENT_REQUEST: '::net-delete-recurring-payment-req',
  DELETE_RECURRING_PAYMENT_RESPONSE: '::net-delete-recurring-payment-res',

  POST_RECURRENCE_CONSENT_FORM_REQUEST: '::net-post-recurrence-consent-form-req',
  POST_RECURRENCE_CONSENT_FORM_RESPONSE: '::net-post-recurrence-consent-form-res',

  GET_CUSTOMER_ACH_DETAILS_REQUEST: '::net-get-customer-ach-details-request',
  GET_CUSTOMER_ACH_DETAILS_RESPONSE: '::net-get-customer-ach-details-response',

  GET_TRANSACTION_PREVIEW_REQUEST: '::net-get-transaction-preview-req',
  GET_TRANSACTION_PREVIEW_RESPONSE: '::net-get-transaction-preview-res',

  GET_ACH_CUSTOMER_REQUEST: '::net-get-ach-customer-req',
  GET_ACH_CUSTOMER_RESPONSE: '::net-get-ach-customer-res',

  TERMINAL_LIST_REQUEST: '::net-get-terminal-list',
  TERMINAL_LIST_RESPONSE: '::net-get-terminal-list-res',

  RUN_TERMINAL_SALE_REQUEST: '::net-do-terminal-sale',
  RUN_TERMINAL_SALE_RESPONSE: '::net-do-terminal-sale-res',

  TERMINAL_REQUEST_STATUS: '::net-get-terminal-request-status',
  TERMINAL_REQUEST_STATUS_RESPONSE: '::net-get-terminal-request-status-res',

  GET_EMV_REPORT_BY_INTERNAL_IDS: '::net-get-emv-report-by-internal-ids',
  GET_EMV_REPORT_BY_INTERNAL_IDS_RESPONSE: '::net-get-emv-report-by-internal-ids-res',

  SEARCH_TRANSACTION_HISTORY_REQUEST: '::net-search-transaction-history-request',
  SEARCH_TRANSACTION_HISTORY_RESPONSE: '::net-search-transaction-history-response',

  DOWNLOAD_TRANSACTION_HISTORY_REQUEST: '::net-download-transaction-history-request',
  DOWNLOAD_TRANSACTION_HISTORY_RESPONSE: '::net-download-transaction-history-response',

  SAVE_ENHANCED_DATA_REQUEST: '::net-save-enhanced-data-request',
  SAVE_ENHANCED_DATA_RESPONSE: '::net-save-enhanced-data-response',
  SAVE_ENHANCED_DATA_RESPONSE_ERROR: '::net-save-enhanced-data-response-error',

  SEARCH_PRODUCTS_REQUEST: '::net-search-products-request',
  SEARCH_PRODUCTS_RESPONSE: '::net-search-products-response',

  GET_ENHANCED_DATA_TRANSACTIONS_REQUEST: '::net-get-enhanced-data-transactions-request',
  GET_ENHANCED_DATA_TRANSACTIONS_RESPONSE: '::net-get-enhanced-data-transactions-response',
  GET_ENHANCED_DATA_TRANSACTIONS_RESPONSE_ERROR: '::net-get-enhanced-data-transactions-response-error',

  GET_TRANSACTION_DETAILS_FOR_MANUAL_FILL_REQUEST: '::net-get-transaction-details-for-enhanced-data-request',
  GET_TRANSACTION_DETAILS_FOR_MANUAL_FILL_RESPONSE: '::net-get-transaction-details-for-enhanced-data-response',

  GET_ED_MERCHANT_TAX_ID_SETTING_REQUEST: '::net-get-ed-merchant-tax-id-setting-request',
  GET_ED_MERCHANT_TAX_ID_SETTING_RESPONSE: '::net-get-ed-merchant-tax-id-setting-response',

  UPDATE_ED_MERCHANT_TAX_ID_SETTING_REQUEST: '::net-update-ed-merchant-tax-id-setting-request',
  UPDATE_ED_MERCHANT_TAX_ID_SETTING_RESPONSE: '::net-update-ed-merchant-tax-id-setting-response',
}

// Hoisting it to the window for easy direct usage of events
// Need to bind it in this way to make tsc and eslint happy
if (window) {
  const key = 'Events'
  window[key] = singleton
}

export default singleton
